/** @jsxImportSource @emotion/react */
import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import Typography from "@mui/material/Typography";

import { useStyles } from "../../styles";

const ErrorMessage = () => {
  const { t } = useTranslation();

  const { errorMessageContainer } = useStyles();

  return (
    <div css={css(errorMessageContainer)}>
      <Typography variant="body1Medium" component="div">
        {t("Dashboard##response error")}
      </Typography>
    </div>
  );
};

export default ErrorMessage;
